import { render, staticRenderFns } from "./ChatPhoto.vue?vue&type=template&id=0276a56a&scoped=true"
import script from "./ChatPhoto.vue?vue&type=script&lang=js"
export * from "./ChatPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0276a56a",
  null
  
)

export default component.exports